export var getHarmonyBuildId = function (componentContext) {
    if (!componentContext) {
        return '';
    }
    var wrapperVersion = componentContext.wrapperVersion;
    var buildId = componentContext.buildVersion;
    var versionPrefix = wrapperVersion
        ? "".concat(wrapperVersion.major, ".").concat(wrapperVersion.minor, ".").concat(wrapperVersion.build, ".").concat(wrapperVersion.revision, "|")
        : '';
    return "".concat(versionPrefix).concat(buildId);
};
//# sourceMappingURL=getHarmonyBuildId.js.map